import { domainErrorKind } from '../api-error-kind';

export const SIGN_IN_FAILURE_MESSAGE = 'We could not sign you in. Please try again.';

export class SignInError extends Error {
	constructor(readonly kind?: string) {
		super(SIGN_IN_FAILURE_MESSAGE);
		this.name = 'SignInError';
	}
}

export function signInFailure(error?: unknown): SignInError {
	return new SignInError(domainErrorKind(error));
}
